import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import React from 'react';
import ReactDOM from 'react-dom';
import './styles/style.css';

import 'react-bootstrap-table/dist/react-bootstrap-table.min';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';

import App from './App';

ReactDOM.render(<App/>, document.getElementById('root'));

// Скасувати реєстрацію service worker (якщо був зареєстрований раніше),
// щоб після деплою не використовувалась стара закешована версія SPA.
if ('serviceWorker' in navigator) {
	navigator.serviceWorker.ready.then((registration) => registration.unregister());
}
